import React, { useEffect, useState } from 'react';
import { Link, useFetcher, useNavigate } from "react-router-dom";

import { useDispatch, useSelector } from "react-redux";

export default function SelectClick(props) {

    const {
        show,
        setShow,
        oriTitle,
        title,
        arrowShow = true,
        // width=200,
        styles={},
        styles2={}
    } = props;

    const dispatch = useDispatch();
    const navigate = useNavigate();

    return (
        <div style={{ cursor: 'pointer' }}
            onClick={() => {
                if (setShow) setShow(!show);
            }}
        >
            <div className={`click_select_box  ${oriTitle != title && 'active border_active'}`} style={styles}>
                <p style={styles2 ? styles2 : {
                    overflow: "hidden",
                    textWrap: "nowrap",
                    textOverflow: "ellipsis",
                }}>{title}</p>
                {arrowShow &&
                    (show ?
                        <img src="./images/icons/uparrow_blue.svg" style={{ transform: 'rotate(180deg)' }} />
                        :
                        <img src="./images/icons/downarrow.svg" />

                    )
                }
            </div>
        </div>
    )
}